import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { treeList } from './conf';
export default {
  data: function data() {
    return {
      treeList: treeList(this),
      curNode: {},
      loading: true
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.curNode = treeList(this)[0].children[0];
    this.$nextTick(function () {
      _this.$refs.tree.setCurrentKey(_this.curNode);
    });
  },
  methods: {
    handleNodeClick: function handleNodeClick(val) {
      if (val.isLeaf) {
        this.curNode = val;
        this.loading = true;
        if (val.type) {
          this.$router.push("/flow/index?type=".concat(val.type, "&label=").concat(val.flow));
        }
      }
    }
  }
};